// extracted by mini-css-extract-plugin
module.exports = {"font":"tableStyles_font__1UZfx"};